import React from 'react';
import getConfig from 'next/config';
import { AiOutlineWarning } from 'react-icons/ai';
import * as Styled from './GlobalMaintenance.styles';
import { useI18n } from 'contexts/i18n';

const GlobalMaintenance = () => {
  const {
    publicRuntimeConfig: { MAINTAINANCE_MESSAGE: message },
  } = getConfig();

  const i18n = useI18n();

  return (
    <Styled.MaintenanceContainer>
      <Styled.MessageBox>
        <div>
          <AiOutlineWarning size={100} color={'orange'} />
        </div>
        <div>{i18n[message] ? i18n[message] : message}</div>
      </Styled.MessageBox>
    </Styled.MaintenanceContainer>
  );
};

export default GlobalMaintenance;
